export const itemsButtonsCtas = [
	{
		id: 'login-astrea',
		type: 'btn',
		title: 'Fazer login no Astrea',
		link: '/astrea-login/',
		btnClass: 'astrea-access-btn',
		showOn: ['home', 'astrea', 'subPage'],
	},
	{
		id: 2,
		type: 'btn-link',
		title: 'Experimentar o Astrea grátis',
		link: '/experimente-o-astrea/',
		btnClass: 'astrea-btn',
		showOn: ['home', 'aurum', 'astrea', 'subPage'],
	},
	{
		id: 3,
		type: 'btn-link',
		title: 'Agendar uma demonstração',
		link: '/experimente-o-themis-ea/',
		btnClass: 'themis-btn',
		showOn: ['themisEA'],
	},
	{
		id: 4,
		type: 'anchor-to',
		title: 'Assistir tour do Themis ',
		link: 'demo-view',
		btnClass: 'themis-btn-ligth for-tablet for-desktop',
		showOn: ['themisDJ', 'themisCalculator'],
	},
	{
		id: 5,
		type: 'btn-link',
		title: 'Agendar uma demonstração',
		link: '/experimente-o-themis-dj/',
		btnClass: 'themis-btn',
		showOn: ['themisDJ', 'themisCalculator'],
	},
]
